import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    import(/* webpackChunkName: "sortablejs" */"sortablejs").then(({default: Sortable}) => {
      const sortable = Sortable.create(this.element, {
        swapThreshold: 1,
        animation: 150,
        disabled: isTouchDevice(),
        ghostClass: 'blue-background-class',
        onChange: () => {
          Rails.ajax({
            url: this.element.dataset.url,
            type: "POST",
            data: `uploads_ids=${Array.from(this.element.children).map(item => item.dataset.id).join(',')}`
          });
        }
      });
    })

  }
}

const isTouchDevice = () => {
  return (('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0));
}
